import {
    Component, EventEmitter, Input, OnInit, Output,
    ViewEncapsulation
} from '@angular/core';
import { ClientModel } from '../../../../shared/models/client.model';
import { AddressModel } from '../../../../shared/models/address.model';
import { CommonHttpService } from '../../../../shared/services/http.service';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import cep, { CEP } from 'cep-promise';

@Component({
    selector: 'account-profile-addresses-item',
    templateUrl: './account.profile.addresses.item.component.html',
    styleUrls: [],
    encapsulation: ViewEncapsulation.None
})
export class AccountProfileAddressesItemComponent implements OnInit {
    @Input('client') client: ClientModel;
    @Input('address') address: AddressModel;
    @Output() canceled: EventEmitter<any> = new EventEmitter();
    @Output() deleted: EventEmitter<any> = new EventEmitter();
    @Output() saved: EventEmitter<AddressModel> = new EventEmitter();

    public zipCodeFound = false;
    public addressFound = false;
    public neighborhoodFound = false;
    public cityFound = false;
    public stateFound = false;
    public updating = false;
    public adding = false;

    constructor(
        protected http: CommonHttpService
    ) {}

    ngOnInit() {
        this.updating = (this.address.id === undefined);
        this.adding = (this.address.id === undefined);
    }

    /**
     * Cancel update process
     **/
    public cancel() {
        this.canceled.emit(this.adding);
        this.adding = false;
        this.updating = false;
        this.addressFound = false;
        this.neighborhoodFound = false;
        this.cityFound = false;
        this.stateFound = false;
        this.zipCodeFound = false;
    }

    /**
     * Call delete api endpoint
     **/
    public delete() {
        this.callDeleteApi().subscribe(() => {
            this.deleted.emit();
        });
    }

    /**
     * Call create or update methods when address id is defined or not
     * defined
     **/
    public save() {
        if (this.adding) {
            return this.create();
        }
        return this.update();
    }

    /**
     * Call create api endpoint with address data.
     **/
    private create() {
        this.callPostApi().subscribe((address: AddressModel) => {
            this.address = address;
            this.saved.emit(this.address);
        });
    }

    /**
     * Call update api endpoint to update address data.
     **/
    private update() {
        this.callDeleteApi().subscribe(() => {
            this.callPostApi(true).subscribe(() => {
                this.updating = false;
                this.saved.emit(this.address);
            });
        });
    }

    /**
     * Call http service with an observable.
     **/
    private callPostApi(updating = false) {
        if (updating && this.address.id !== undefined) {
            delete this.address.id;
        }

        return new Observable(observable => {
            this.http
                .useAuth()
                .post(`/account/clients/${this.client.id}/addresses`, this.sanitizeZipCode(this.address))
                .subscribe((response: Response) => {
                    observable.next(response.json().data);
                    observable.complete();
                });
        });
    }

    /**
     * Call http service with an observable.
     **/
    private callDeleteApi() {
        return new Observable(observable => {
            this.http
                .useAuth()
                .delete(`/account/clients/${this.client.id}/addresses/${this.address.id}`)
                .subscribe(() => {
                    observable.next();
                    observable.complete();
                });
        });
    }
    /**
     * This must keep only digits at zip code from address instance.
     **/
    private sanitizeZipCode(address: AddressModel): AddressModel {
        address.zip_code = address.zip_code.replace(/\D/g, '');

        return address;
    }

    /**
     * Search zip code data at ViaCEP database.
     **/
    public findZipCode() {
        const zipCode = this.address.zip_code.replace(/\D/g, '');
        if (zipCode.length === 8) {
            cep(zipCode).then((result: CEP) => {
                this.zipCodeFound = true;

                this.address.country = 'BRA';

                this.address.address = result.street;
                this.addressFound = result.street !== '';

                this.address.city = result.city;
                this.cityFound = result.city !== '';

                this.address.state = result.state;
                this.stateFound = result.state !== '';

                this.address.neighborhood = result.neighborhood;
                this.stateFound = result.state !== '';
                this.neighborhoodFound = result.neighborhood !== '';
            }).catch(() => {
                this.address.country = 'BRA';
                
                this.address.address = '';
                this.addressFound = false;

                this.address.city = '';
                this.cityFound = false;

                this.address.state = '';
                this.stateFound = false;

                this.address.neighborhood = '';
                this.stateFound = false;

                this.zipCodeFound = false;
            });
        } else {
            this.addressFound = false;
            this.neighborhoodFound = false;
            this.cityFound = false;
            this.stateFound = false;
            this.zipCodeFound = false;
        }
    }

    /**
     * Request update process.
     **/
    public requestUpdate() {
        this.updating = true;
        this.addressFound = true;
        this.neighborhoodFound = true;
        this.cityFound = true;
        this.stateFound = true;
        this.zipCodeFound = true;
    }

    /**
     * Load zip code mask pattern.
     * */
    public loadZipCodeMask() {
        return [
            /\d/, /\d/, /\d/, /\d/, /\d/, '-',
            /\d/, /\d/, /\d/
        ];
    }
    /**
     * Load state mask pattern.
     * */
    public loadStateMask() {
        return [/[A-Z]/, /[A-Z]/];
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src4078178155/src/src/app/account/profile/addresses/item/account.profile.addresses.item.component.ts